<template>
  <div class="student_report_shengya">
    <div class="rzqn">
      <div class="rzqnTitle">
        职业类型与评估指标分析结果
      </div>
      <table>
        <tbody>
          <tr>
            <th>职业类型</th>
            <th>指标类型</th>
            <th>指标得分</th>
            <th width="355">得分/匹配度</th>
          </tr>
        <tr v-for="(item,index) in scores" :key="index">
          <td v-if="index%2==0" class="blue" rowspan="2">{{item.name}}</td>
          <td v-if="index%2==0" >兴趣倾向</td>
          <td v-if="index%2==0" >{{item.hscore}}</td>
          <td v-if="index%2==0" >
            <div  :style="{ width:item.hscore/100*355+'px'}"
                 :class="item.hscore<=20&&'b-red'||
                  item.hscore>20&&item.hscore<=40&&'b-orange'||
                  item.hscore>40&&item.hscore<=60&&'b-yellow'||
                  item.hscore>60&&item.hscore<=80&&'b-green'||
                  item.hscore>80&&'b-blue'"
            >
            </div>
          </td>
          <td v-if="index%2==1" >认知潜能</td>
          <td v-if="index%2==1" >{{item.cscore}}</td>
          <td v-if="index%2==1" >
            <div  :style="{ width:item.cscore/100*355+'px'}"
                  :class="item.cscore<=20&&'b-red'||
                  item.cscore>20&&item.cscore<=40&&'b-orange'||
                  item.cscore>40&&item.cscore<=60&&'b-yellow'||
                  item.cscore>60&&item.cscore<=80&&'b-green'||
                  item.cscore>80&&'b-blue'"
            >
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  name: "zysy",
  props:['reportId'],
  data(){
    return {
      scores:[],
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_report + this.ports.consultant.student.report.zylx,{
        report_id:this.reportId
      },{
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then(res=>{
        if(res.data.code==0){
          let scores1 = res.data.result&&res.data.result.scores||[]
          let scores2 = JSON.parse(JSON.stringify(scores1));
          let number = scores1.length;
          let scores = [];
          for(let i=0;i<number;i++){
            scores.push(scores1[i])
            scores.push(scores2[i])
          }
          this.scores = scores
        }else{

        }
      })
    }
  },
  mounted() {
    this.getData()
  },
}
</script>

<style scoped lang="less">
  @import '../../css/evaluationReport.less';
</style>